import { styled } from '@mui/system';

export const Title = styled('div')(({ theme }) => ({
  fontWeight: '500',
  lineHeight: '1.2',
  letterSpacing: '3px',
  fontFamily: 'FuturaLTPro-Medium',
  fontSize: '32px',
  color: '#fff',
  textTransform: 'uppercase',
}));

export const PassportWrapper = styled('div')(({ theme }) => ({
  marginTop: '24px',
  display: 'flex',
}));

export const Icon = styled('img')(({ theme }) => ({
  marginRight: '16px',
}));
